







































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteCaixasCirurgicasStore from '@/components/Suporte/Store/SuporteCaixasCirurgicasStore'

@Component
export default class ComponentModalSuporteEditarCaixaCirurgica extends Vue {
  $refs!: { editCaixaCirurgicaForm: any }

  loadCaixaCirurgica: boolean = false
  loadEditCaixaCirurgica: boolean = false
  editCaixaCirurgica: boolean = false

  editCaixaCirurgicaForm: any = {
    valid: true,
    hisId: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  get getSuporteCaixasCirurgicasStore() {
    return getModule(SuporteCaixasCirurgicasStore, this.$store)
  }

  get showModalEditCaixaCirurgica() {
    return this.getSuporteCaixasCirurgicasStore.modal.editCaixaCirurgica
  }

  set showModalEditCaixaCirurgica(value: boolean) {
    this.getSuporteCaixasCirurgicasStore.setModal({ name: 'editCaixaCirurgica', value })
  }

  get loadingEditCaixaCirurgica() {
    return this.loadEditCaixaCirurgica
  }

  set loadingEditCaixaCirurgica(value: boolean) {
    this.loadEditCaixaCirurgica = value
  }

  get genericCaixasCirurgicas() {
    return this.getSuporteCaixasCirurgicasStore.genericCaixasCirurgicas
  }

  async putCaixaCirurgica() {
    this.loadingEditCaixaCirurgica = true
    if (!this.$refs.editCaixaCirurgicaForm.validate()) {
      this.loadingEditCaixaCirurgica = false
      return
    }
    const response = await this.getSuporteCaixasCirurgicasStore.putCaixaCirurgicaToHospital()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Caixa cirúrgica atualizada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.showModalEditCaixaCirurgica = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingEditCaixaCirurgica = false
  }

  @Watch('showModalEditCaixaCirurgica')
  onChangeShowModalInsertCaixaCirurgica(value: boolean) {
    if (!value) {
      this.$refs.editCaixaCirurgicaForm.resetValidation()
      this.getSuporteCaixasCirurgicasStore.clearCaixaCirurgica()
      this.getSuporteCaixasCirurgicasStore.setMode({ mode: 'CREATE' })
    }
  }
}
